<template>
  <section class="sme-container__info">
    <template>
      <div
        v-for="(item,index) in info"
        :key="index"
        class="box">
        <table
          class="table"
          :class="item.class" >
          <tr class="th font-14">{{item.title}}</tr>
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.noShow"
            :key="sumIndex"
            class="tr">
            <td class="fw-600">{{ sumItem.name }}</td>
            <td
              v-if="sumItem.type == 'array'"
            >
              <span
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum.item">{{sum.item}}<br></span>
            </td>
            <td
              v-else-if="sumItem.value"
              v-copy="sumItem.value">{{sumItem.value}}</td>
            <td
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </td>
          </tr>
        </table>
      </div>
      <div
        class="box">
        <table
          class="table mg-b-10">
          <tr class="th">Employee's Compensation Details</tr>
          <section>
            <tr class="tr">
              <td class="fw-600">	Any Self-Employed Person(s), Partner or Sole Proprietor for your business?</td>
              <td>{{ getOptionName('smeYesNoOptions', ec_detail.self_employed_ind)}}</td>
            </tr>
            <section
              v-for="(occ_item,index) in ec_detail.occ_information_list"
              :key="'occ_item'+index">
              <tr
                v-if="showOCc"
                class="tr">
                <td class="fw-600">Occupation</td>
                <td v-copy="getSMEOptionName(smeOptions.ec_occupation, occ_item.occ_id)">{{ getSMEOptionName(smeOptions.ec_occupation, occ_item.occ_id)}}</td>
              </tr>
              <section
                v-for="(occ_detail_item,index) in occ_item.occ_detail"
                :key="'occ_detail_item'+index">
                <tr
                  class="tr">
                  <td class="fw-600">{{ getSMEOptionName(smeOptions.ec_nature, occ_detail_item.nature_time)}}</td>
                  <td v-copy="getOptionName('smeYesNoOptions', occ_detail_item.nature_time_enable)">{{ getOptionName('smeYesNoOptions', occ_detail_item.nature_time_enable)}}</td>
                </tr>
                <tr class="tr">
                  <td class="fw-600">No. of Employee(s)</td>
                  <td v-copy="occ_detail_item.no_of_employee">{{  occ_detail_item.no_of_employee}}</td>
                </tr>
                <tr class="tr">
                  <td class="fw-600">Estimated Annual Earnings</td>
                  <td v-copy="occ_detail_item.annual_salary">{{  occ_detail_item.annual_salary}}</td>
                </tr>
              </section>
            </section>
          </section>
        </table>
      </div>
    </template>
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinSMEInfo from '@/mixins/smeInfo'
import {mapState} from 'vuex'

export default {
  name: 'cateringInfo',
  mixins: [MixinOptions,MixinSMEInfo],
  props: {
    title: {
      type: Boolean,
      default: true
    },
  },
  data(){
    return{
      // compareData:
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
  },

  methods: {
    showCompare(item, field) {
      var change = field
      return change
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../info";
</style>
